import { NetworkActionPrefix, ActionType } from '../utils/constants';
import { NotificationReportApi, UserNotificationEventSourceApi, UserNotificationUserSettingsApi } from 'for-straction-service-api'
import { networkAPIAction } from '../utils/actionCreatorsFactory';

export const loadUserNotificationEventSources = () =>
    networkAPIAction(UserNotificationEventSourceApi, 'userNotificationEventSourceLoadAllGet', NetworkActionPrefix.LOAD_USER_NOTIFICATION_EVENT_SOURCES_PREFIX);

export const loadAllUserNotificationUserSettings = () =>
    networkAPIAction(UserNotificationUserSettingsApi, 'userNotificationUserSettingsLoadAllGet', NetworkActionPrefix.LOAD_ALL_USER_NOTIFICATION_USER_SETTINGS_PREFIX);

export const updateAllUserNotificationUserSettings = (entities, userID) => {
    return networkAPIAction(UserNotificationUserSettingsApi, 'userNotificationUserSettingsUpdateAllUserSettingsPut', NetworkActionPrefix.UPDATE_ALL_USER_NOTIFICATION_USER_SETTINGS_PREFIX, { entities, userID }, entities)
}